<template>
  <div class="el-section">
    <div
      class="emd-container _highlight_header _header_spaced _footer_spaced_sm"
    >
      <div class="emd-container__header">
        <h2 class="emd-text _size_section">
          {{ $t('recipients.details.list.transfer.title') }}
        </h2>
      </div>
    </div>
    <div class="emd-card-grid">
      <div class="el-grid-list el-section _separator">
        <div class="el-bounds">
          <div class="demo-grid-item _separator">
            <label class="emd-text _type_caption">{{
              $t('recipients.details.list.transfer.transfer_enabled')
            }}</label>
            <p
              class="emd-card-grid__line emd-text"
              style="font-weight: bold"
              v-bind:class="status"
            >
              {{ $t(automatic) }}
            </p>
          </div>
        </div>
        <template v-if="data && data.transfer_enabled">
          <div class="el-bounds">
            <div class="demo-grid-item _separator">
              <label class="emd-text _type_caption">{{
                $t('recipients.details.list.transfer.transfer_interval')
              }}</label>
              <p class="emd-card-grid__line emd-text">
                {{ data.transfer_interval_label }}
              </p>
            </div>
          </div>
          <div class="el-bounds">
            <div class="demo-grid-item _separator">
              <label class="emd-text _type_caption">{{
                $t('recipients.details.list.transfer.transfer_day')
              }}</label>
              <p class="emd-card-grid__line emd-text">{{ $t(day) }}</p>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { statusClass } from '@/filters'
import { transferInterval } from '@/filters/recipients'

export class TransferSettings {
  constructor (transferDay, transferEnabled, interval) {
    this.transfer_day = transferDay
    this.transfer_enabled = transferEnabled
    this.transfer_interval = transferInterval(interval)
    this.transfer_interval_label = interval
  }
}

export default {
  name: 'TransferSettings',
  props: {
    data: new TransferSettings()
  },
  computed: {
    automatic () {
      return this.data.transfer_enabled
        ? 'recipients.details.list.transfer.type.enabled'
        : 'recipients.details.list.transfer.type.disabled'
    },
    status () {
      const status = this.data.transfer_enabled ? 'active' : 'canceled'
      return statusClass(status)
    },
    day () {
      return this.data.transfer_day || '-'
    },
    showInterval () {
      return this.data.transfer_interval !== 'Daily'
    }
  }
}
</script>
